import { DELETE, GET, POST, PUT } from './api';

const table = 'cobrancas';

export const Create = async (params) => {
  return await POST(`/${table}`, params, true);
};

export const Read = async (filters = '') => {
  return await GET(`/${table}${filters}`, true);
};

export const ReadOne = async (id) => {
  return await GET(`/${table}/${id}?populate=*`, true);
};

export const Update = async (params, id) => {
  return await PUT(`/${table}/${id}`, params, true);
};

export const Delete = async (id) => {
  return await DELETE(`/${table}/${id}`, true);
};

export const baixaParcela = async (params, id) => {
  return await PUT(`/${table}/baixaparcela/${id}`, params, true);
};

export const msgRenegociacaoCliente = async (params, id) => {
  return await PUT(`/${table}/msgrenegociacaocliente/${id}`, params, true);
};
